import type { CommonResponse } from 'types/api'
import type { ResponseFollowUpReflectionDocument } from 'types/kinerja-pelaksanaan'

export const dummyFollowUpReflectionDocument: CommonResponse<ResponseFollowUpReflectionDocument> =
  {
    data: {
      detail: {
        achievement: '',
        additionalAchievement: '',
        additionalChallenge: '',
        additionalImprovementPlan: '',
        additionalInspiration: '',
        challenge: '',
        improvementPlan: '',
        inspiration: '',
      },
      state: 'SUBMITTED',
    },
    meta: {},
  }
